<div class="container">
  <div class="logo"><logo></logo></div>
  <h5 class="title">Healthcare deserves nice things too</h5>
  <p class="text">
    Rivet ensures that providers can concentrate on patient care and growth,
    rather than the complexities of healthcare revenue cycle management
  </p>
</div>
